import { mapActions, mapGetters } from 'vuex'

import SheetWrapper from '@/components/SheetWrapper/index'
import Card from '@/components/Card/index'

export default {
  name: 'round',
  props: {
    roundId: String,
    baseUrl: String,
    pageArr: Array
  },
  components: {
    SheetWrapper,
    Card
  },
  data: () => ({
    cardDesc: 'Points Earned',
    homePoints: 0,
    awayPoints: 0,
    drawPoints: 0,
    bonusPoints: 0,
    pointsEarned: 0,
    breakdownVisible: false,
    threeDrawPoints: 0,
    bankerPoints: 0,
    fiveGoalGamePoints: 0,
    pointsBg: require('@/assets/points.svg'),
    showCurrentRound: false,
    loading: true
  }),
  computed: {
    ...mapGetters('results', {
      results: 'PLAYER_RESULTS'
    }),
    ...mapGetters('auth', {
      nearestGame: 'NEAREST_GAME'
    })
  },
  methods: {
    ...mapActions('results', {
      fetchResultsAction: 'FETCH_PLAYER_RESULTS'
    }),
    getTeamImage(iconSrc) {
      return iconSrc === 'Not available in Demo' || iconSrc === null
        ? require('@/assets/profile-avatar.svg')
        : iconSrc
    },
    calculateMatchScore(predictionData) {
      if (predictionData) {
        const {
          correctAwayWinScore,
          correctDrawWinScore,
          correctHomeWinScore,
          correctScoreline
        } = predictionData
        return (
          correctAwayWinScore +
          correctDrawWinScore +
          correctHomeWinScore +
          correctScoreline
        )
      }

      return 0
    },
    displayPoints(point) {
      return `${point}pt${point <= 1 ? '' : 's'}`
    },
    clearData() {
      this.homePoints = 0
      this.awayPoints = 0
      this.drawPoints = 0
      this.bonusPoints = 0
      this.pointsEarned = 0
      this.threeDrawPoints = 0
      this.bankerPoints = 0
      this.fiveGoalGamePoints = 0
    },
    toggleBreakdown(e) {
      e.stopPropagation()
      this.breakdownVisible = !this.breakdownVisible
    },
    hideBreakdown() {
      this.breakdownVisible = false
    },
    chooseOverrideRoundIfExists(game) {
      return game.overrideRound || game.roundNum
    }
  },
  filters: {
    nullNumberCatcher(value) {
      return value !== null ? value : '*'
    }
  },
  watch: {
    pageArr(pageList) {
      // Uncomment to enable postponed restrictions
      const showCurrentRound = this.nearestGame.statusShort !== 'NS'
      // const showCurrentRound = (this.nearestGame.statusShort !== 'NS' && this.nearestGame.statusShort !== 'PST')
      const defaultCurrentRound = parseInt(
        pageList.find(item => item.defaultPage).param
      )
      const useRoundNum = this.chooseOverrideRoundIfExists(this.nearestGame)

      const roundId = parseInt(this.roundId) || defaultCurrentRound

      const isCurrentRound = roundId === parseInt(useRoundNum)
      const selectedRoundIsCurrentRound =
        parseInt(this.roundId) === parseInt(useRoundNum)
      const userId = this.$route.params.userId
      const payload = {
        roundId: isCurrentRound ? defaultCurrentRound : roundId,
        userId
      }
      this.showCurrentRound = isCurrentRound ? showCurrentRound : true
      if (isCurrentRound && !showCurrentRound && !selectedRoundIsCurrentRound) {
        this.$router.push({
          path: `${this.baseUrl}/${useRoundNum - 1}`
        })
      }
      this.fetchResultsAction(payload).then(() => {
        const { success, data } = this.results
        if (success && data.length > 0) {
          data.forEach(item => {
            if (item.prediction) {
              const {
                correctHomeWinScore,
                correctAwayWinScore,
                correctDrawWinScore,
                correctScoreline,
                fiveGoalGameScore,
                threeDrawScore,
                bankerScore
              } = item.prediction

              this.homePoints += correctHomeWinScore
              this.awayPoints += correctAwayWinScore
              this.drawPoints += correctDrawWinScore

              this.homePoints += correctHomeWinScore > 0 ? correctScoreline : 0
              this.awayPoints += correctAwayWinScore > 0 ? correctScoreline : 0
              this.drawPoints += correctDrawWinScore > 0 ? correctScoreline : 0

              this.threeDrawPoints += threeDrawScore || 0
              this.bankerPoints += bankerScore || 0
              this.fiveGoalGamePoints += fiveGoalGameScore || 0
            }
          })

          this.bonusPoints =
            this.threeDrawPoints + this.bankerPoints + this.fiveGoalGamePoints

          this.pointsEarned =
            this.homePoints +
            this.awayPoints +
            this.drawPoints +
            this.bonusPoints
          this.loading = false
        }
      })
    }
  },
  activated() {
    this.loading = true
  },
  deactivated() {
    this.loading = true
    this.clearData()
  }
}
